import TermsPageView from 'src/pages/Mypage/TermsPage/view'

const TermsPage = () => {
  return <TermsPageView />
}
export default TermsPage
